module.exports = __webpack_public_path__ + "media/svg-new/user-81419234.svg";